import { render, staticRenderFns } from "./nodeDetail.vue?vue&type=template&id=25dc9358&scoped=true&"
import script from "./nodeDetail.vue?vue&type=script&lang=js&"
export * from "./nodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./nodeDetail.vue?vue&type=style&index=0&id=25dc9358&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc9358",
  null
  
)

export default component.exports